import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forEach } from '@angular/router/src/utils/collection';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { activeTrainingPageEnum, TrainingManagementComponent } from '../training-management/training-management.component';
import { AutoTrainingCodeModel } from './../../../communication-structure/auto-training-code-model';
import { PageViewComponent } from './../../page-view/page-view.component';
import { Table, Types } from './../../table/table.component';
import { EditAutoTrainingCodeRequestModel } from '../../../communication-structure/edit-auto-training-code-request-model';
import { SelectListTypeForEdit } from '../../../communication-structure/select-list-type-for-edit';

@Component({
  selector: 'app-inactive-auto-training-code',
  templateUrl: './inactive-auto-training-code.component.html',
  styleUrls: ['./inactive-auto-training-code.component.scss']
})

export class InactiveAutoTrainingCodeComponent extends PageViewComponent implements OnInit {
  private getClientAtcListEndPoint: string;
  private editAtcEndPoint: string;

  systemIdToSend: string;

  public table: Table[][];
  public header: Table[];
  public dataFromApi: Array<AutoTrainingCodeModel>;
  public editAutoTrainingTitle: string;
  public autoTrainingCodeNameToEdit: string;
  public autoTrainingCreationDate : string; 
  public autoTrainingExpirationDate : string; 
  public autoTrainingStatus: string;
  saveBtnClicked: boolean;

  private autoTrainingButtonIdentify : number;
  private autoTrainingIdToDe_Reactivate : string;
  private atcNameCol: string;
  private startDateCol: string;
  private endDateCol: string;
  private inactivateDateCol: string;
  private viewCol: string;
  private statusActive: string;
  private statusInactive: string;
  private statusCol: string;
  private changeStatusCol: string;
  public autoTrainingIdToEdit: string;
  private pageTitle: string;
  private pageDesc: string;
  public reactivateBtnVisible = true;
  public editInactive = false;
  public applyBorder = false;
  public forButton : string;
  public forButtonIcon : string;
  public activeFlag :boolean;
  constructor(
    ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected router: Router,
    protected loginService: LoginService,
    stringTableService: StringTableService

  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.inactiveAutoTrainingCode);
    this.initializeView();
    this.getClientAtcList('2');
  }

  initializeView() {
    this.pageTitle = this.stringTableService.getString('inactiveAutoTrainingCode', 'pageTitle');
    this.pageDesc = this.stringTableService.getString('inactiveAutoTrainingCode', 'pageDesc');
    this.atcNameCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'atcNameCol');
    this.startDateCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'startDateCol');
    this.endDateCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'endDateCol');
    this.inactivateDateCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'inactivateDateCol');
    this.viewCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'viewCol');
    this.statusCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'statusCol');
    this.statusActive = this.stringTableService.getString('inactiveAutoTrainingCode', 'statusActive');
    this.statusInactive = this.stringTableService.getString('inactiveAutoTrainingCode', 'statusInactive');
    this.changeStatusCol = this.stringTableService.getString('inactiveAutoTrainingCode', 'changeStatusCol');
    this.editAutoTrainingTitle = this.stringTableService.getString('inactiveAutoTrainingCode', 'editAutoTrainingTitle');
    this.getClientAtcListEndPoint = this.stringTableService.getEndpoint('GetClientATCList');
    this.editAtcEndPoint = this.stringTableService.getEndpoint('EditAtc');
 
  }

  onEditBtnClicked(tableData) {
    this.autoTrainingCodeNameToEdit = tableData.tableRow[0].title;
    this.autoTrainingCreationDate = tableData.tableRow[1].title;
    this.autoTrainingExpirationDate = tableData.tableRow[2].title;
    this.autoTrainingStatus = tableData.tableRow[4].title;
    this.autoTrainingIdToEdit = tableData.tableRow[7].title;
    this.autoTrainingButtonIdentify = tableData.toIdentify;
    this.autoTrainingIdToDe_Reactivate = tableData.tableRow[5].title;
    if(this.autoTrainingButtonIdentify === 2){
      if(this.autoTrainingIdToDe_Reactivate==='Deactivate')
      {
        this.editAtc(false);
        this.activeFlag = false;
        return;
      }
      if(this.autoTrainingIdToDe_Reactivate==='Reactivate')
      {
        this.editAtc(true);
        this.activeFlag = true;
        return;
      }
    }
    this.editInactive = true;
  }

  /**Gets all the client atc list with the specified active status
   * @param activeStatus the type of ATC list which we want to fetch 0 - inactive, 1 - active, 2 - both
   */
  getClientAtcList(activeStatus) {
    this.getDataFromApi(this.getClientAtcListEndPoint, { clientId: this.currentUserClientID, active: activeStatus })
      .subscribe(
      this.handleAtcData.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientAtcList.bind(this, activeStatus), false)
      );
  }

  /**
   * @param data the ATC received from the Server after making a successfull request
   */
  private handleAtcData(data) {
    this.hideLoader();
    if (data.system === 'Windows Only') {
      this.systemIdToSend = this.windowsOnlySystemID;
    } else {
      this.systemIdToSend = this.systemID;
    }
    this.dataFromApi = data.autoTrainingCodeList;
    this.formTable();
  }

  formTable() {
    this.table = [[]];
    this.header = [];
    this.header = [
      new Table(Types.TEXT, 'table-header', this.atcNameCol),
      new Table(Types.TEXT, 'table-header', this.startDateCol),
      new Table(Types.TEXT, 'table-header', this.endDateCol),
      new Table(Types.TEXT, 'table-header', this.inactivateDateCol),
      new Table(Types.TEXT, 'table-header', this.statusCol),
      new Table(Types.TEXT, 'table-header', this.changeStatusCol),
      new Table(Types.TEXT, 'table-header', this.viewCol)
    ];

    for (const tableCell of this.dataFromApi) {
      if(tableCell.status == "Active") {
        this.forButton = "Deactivate";
        this.forButtonIcon = 'tg-diff-ignored';
      }
      else {
        this.forButton = "Reactivate";
        this.forButtonIcon = 'tg-check-circle';
      }
      this.table.push([new Table(Types.TEXT, 'table-data', tableCell.autoTrainingCodeName),
      new Table(Types.DATE, 'table-data', this.formatDate(this.dateConversion(tableCell.creationDate))),
      new Table(Types.DATE, 'table-data', this.formatDate(this.dateConversion(tableCell.expirationDate))),
      new Table(Types.DATE, 'table-data', this.formatDate(this.dateConversion(tableCell.dateInactive))),
      new Table(Types.TEXT, 'table-data',tableCell.status),
      new Table(Types.BUTTON_AC_DEAC, this.forButtonIcon +' table-button ', this.forButton),
      new Table(Types.BUTTON, 'tg-eye table-button ', 'View'),
      new Table(Types.HIDDEN_ID, 'table-data', tableCell.autoTrainingCodeId)]);
    }
    if (this.table.length > 9) {
      this.applyBorder = true;
    }

  }
  
  onEditingCanceled() {
    this.editInactive = false;
    this.initializeView();
  }

  editAtc(activeFlag) {
    const dataForEditAtc: EditAutoTrainingCodeRequestModel = {
      clientId: this.currentUserClientID,
      system: this.systemIdToSend,
      autoTrainingCodeName: this.autoTrainingCodeNameToEdit,
      creationDate: this.autoTrainingCreationDate,
      expirationDate: this.autoTrainingExpirationDate,
      active: activeFlag,
      forceOrder: true,
      reminderFrequency : "",
      proctoreActive : false,
      trainingsInAutoTrainingCodeList :null,
      description : ""
    };
    this.postDataToApi(this.editAtcEndPoint, dataForEditAtc)
      .subscribe(this.handleEditAtcSuccess.bind(this),
      this.handleSubscriptionError.bind(this, this.editAtc.bind(this, this.reactivateBtnVisible), true));
  }

  
  handleEditAtcSuccess() {
    this.hideLoader();
    this.validationPopup = true;
    
    if (this.saveBtnClicked) {
      this.showDialog({
        title: this.stringTableService.getString('popupMessages', 'atcSaveTitle'),
        body: this.autoTrainingCodeNameToEdit + ' ' + this.stringTableService.getString('popupMessages', 'atcSaveDesc')
      });
      this.saveBtnClicked = false;
    } else if (this.activeFlag) {
      this.showDialog({
        title: this.stringTableService.getString('popupMessages', 'atcActiveTitle'),
        body: this.autoTrainingCodeNameToEdit + ' ' + this.stringTableService.getString('popupMessages', 'atcActiveDesc')
      }, () => {
      });
    } else {
      this.showDialog({
        title: this.stringTableService.getString('popupMessages', 'atcInactiveTitle'),
        body: this.autoTrainingCodeNameToEdit + ' ' + this.stringTableService.getString('popupMessages', 'atcInactiveDesc')
      }, () => {
      });
    }
    this.getClientAtcList('2');
  }

  showInactivateHome() {
    this.router.navigate(['inactive-autotraining']);
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/inactive-auto-training-code/inactive-auto-training-code.component.ts